<template>
  <div class="content" v-loadmore="loadMore" v-onscroll="scroll">
    <!-- <card-wk :data="list"></card-wk> -->
    <div>
      <card-course v-for="item in list" :key="item.id" :data="item"></card-course>
    </div>
    <loading :more="more" :loaded="loaded"></loading>
    <!-- 会员提示 -->
    <!-- <div v-show="show" class="vip-spec" :class="{'no-vip':!user.isvip}"><img src="~common/image/vip-logo.png" alt="">会员可免费观看精品微课<router-link tag="a" to="/vip" href="javascript:;">马上开通会员>></router-link></div> -->
  </div>
</template>
<script type="text/ecmascript-6">
// import CardWk from './card-wk.vue'
import CardCourse from '../card/card-course'
import Loading from '../base/loading/loading2'
import {RES_OK, PAGE_SIZE} from '@/api/config'
import {getJpList} from '@/api/jp.js'
import {mapGetters} from 'vuex'
export default {
  data() {
    return {
      loaded: false,
      more: true,
      list: [],
      page: 1,
      show: true // 控制vip说明的显示
    }
  },
  components: {
    // CardWk,
    CardCourse,
    Loading
  },
  computed: {
    ...mapGetters(['user'])
  },
  mounted() {
    this._getFfjpList()
  },
  methods: {
    scroll(top) {
      // console.log(top)
      // 小于30才显示
      this.show = top <= 30
    },
    loadMore() {
      if (this.more && this.loaded) {
        this.loaded = false
        this._getFfjpList()
      }
    },
    _getFfjpList() {
      getJpList(this.page, PAGE_SIZE, '', 1, 1).then((res) => {
        let data = res.data
        if (data && data.code === RES_OK && data.data) {
          if (data.data.length) {
            let pageSize = 0
            data.data.forEach((item, index) => {
              if (item.data.length) {
                pageSize += item.data.length
                this.list.push(...item.data)
              }
            })
            this.loaded = true
            this.page++
            // 加载完毕
            this.more = pageSize >= PAGE_SIZE
          }
        }
      })
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .content
    // padding-top: size(90 + 72 + 30*2)
    padding-bottom size(60)
    padding-left: size(30)
    padding-right: size(30)
  .wrap
    padding size(30)
  .no-record
    font-size size(28)
    text-align center
    color #999
    padding size(60)
  .vip-spec
    position fixed
    left 0
    bottom size(100)
    width 100%
    text-align center
    background lighten($color-vip, 60%)
    color #6c5312
    font-size size(26)
    padding size(14) size(30)
    line-height 1
    a
      display none
      float right
      color #6c5312
    img
      height size(26)
      display inline-block
      vertical-align bottom
      margin-right size(6)
      position relative
      top -1px
    &.no-vip
      text-align left
      a
        display inline
</style>



// WEBPACK FOOTER //
// src/components/jpff/jpff-wk.vue